import { Box } from "@mui/material";
import type { JSX } from "react";

import { AutonomousDraftingPanel } from "./AutonomousDraftingPanel.js";
import { PlatformAccountsPanel } from "./PlatformAccountsPanel.js";
import { PublishingControlsPanel } from "./PublishingControlsPanel.js";

/**
 * Marketing → Settings tab. Stacked panels: the autonomous-drafting switch
 * (suggest-ideas-only vs auto-draft), connect/manage the social accounts the
 * agent posts to, and the master autonomous-publishing switch. Reaching the
 * tab needs `marketing:view`, but every CONTROL is "Manage Marketing settings"
 * (`marketing:manage`) — gated inside each panel via `useCan('marketing:manage')`,
 * with the server enforcing the same wall. Read-only viewers (incl. a
 * `marketing_manager` without manage) see status but no controls.
 */
export function MarketingSettingsPage(): JSX.Element {
  return (
    <Box sx={{ display: "grid", gap: 2 }} data-testid="marketing-settings">
      <AutonomousDraftingPanel />
      <PlatformAccountsPanel />
      <PublishingControlsPanel />
    </Box>
  );
}
